import { createTheme } from "@material-ui/core";

const light = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#004BBD",
      dark: "#003484",
      light: "#336fca",
    },
    secondary: {
      main: "#24C1ED",
      dark: "#1987a5",
      light: "#4fcdf0",
    },
  },
});

export default light;
